import React, { Component } from 'react'
import 'bootstrap/dist/css/bootstrap.css';
import axios from 'axios';
import CustomHeader from '../components/Header'
import { CardDeck, Row, Col, Container, Card,Modal,Button } from 'react-bootstrap'
 
import Select from 'react-select'
import GroupVRNSelect from '../containers/comps/GroupVRNSelectContainer'
import AdvanceTableWithActionButton from '../components/Tables/AdvanceTableWithActionButton';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import axiosConfig from "../config/axiosConfig";

const customStyles = {
    option: (provided, state) => ({
        ...provided,
        color: state.isSelected ? 'black' : 'black',
        backgroundColor: state.isSelected ? '#7367f0' : 'white'
    }),
    control: (provided) => ({
        ...provided,
        borderRadius: '50px',
        borderColor: '#7367f0'

    })
}


class MyReminderActivity extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            
            VRNMappingID: 0,
            vehiclesOptions: [
                { value: '0', label: 'All Vehicles' },
                { value: '1', label: 'Vehicle(s)' },
                { value: '2', label: 'Vehicles by Group(s)' }
            ],
            entriesOptions: [
                { value: '0', label: '25' },
                { value: '1', label: '50' },
                { value: '2', label: '100' }
            ],
            Activitydata: [],
            Activitycolumns: [
                
                { "HeaderText": "VRN", "MappingColomn": "vrn" },
                { "HeaderText": "Activity", "MappingColomn": "maintenanceActivity" },
                { "HeaderText": "Last Activity Date", "MappingColomn": "activityDate" },
                { "HeaderText": "Reminder Date", "MappingColomn": "reminderDate" },
                { "HeaderText": "Reminder Odometer", "MappingColomn": "reminderOdometer" },
                { "HeaderText": "Comments", "MappingColomn": "comments" },
                { "HeaderText": "SMS", "MappingColomn": "sms" },
                { "HeaderText": "Email", "MappingColomn": "email" },
            ],
            Option: 1,
            Group: 0,
            Vehicle: 0,
            vehicleHealthId:0,
            
            openModel:false,
            closeModel:false,
            activityMarkedDate:'',
            activityMarkedComments:'',
            DeletedRecordId:0,
            
        }


        this.changeHandler = this.changeHandler.bind(this)
        this.submitHandler = this.submitHandler.bind(this)
        this.onChange=this.onChange.bind(this);

        this.optionChange = this.optionChange.bind(this)
        this.groupChange = this.groupChange.bind(this)
        this.vehicleChange = this.vehicleChange.bind(this)
        this.GetSelectedRecords_Id=this.GetSelectedRecords_Id.bind(this);
        this.closeModel=this.closeModel.bind(this);
        this.bindGrid=this.bindGrid.bind(this);
        this.GetDeleteSelectedRecords=this.GetDeleteSelectedRecords.bind(this);

    }

    MarkAsDoneSave = e => {
        debugger;
        e.preventDefault();
        console.log(this.state.mobileNo1);
        axiosConfig.post("Portal/MarkVehicleActivityAsDone",
                {
                    ActivityId: this.state.vehicleHealthId,
                    ActivityDate: this.state.activityMarkedDate,
                    Comments: this.state.activityMarkedComments,
                }
            )
            .then(Response => {
                this.setState({ openModel: false });
                this.bindGrid();
                Swal.fire({
                    icon: 'success',
                    title: 'Marked Successfully',
                })
            })
            .catch(error => {
                Swal.fire({
                    title: error.response.data.errorMessage,
                    text: 'Some Error !',
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            })

    }
    
    onChange(p) {
        var newState = {};

        if(p.target.name == "activityMarkedComments")
        {
            newState[p.target.name] = p.target.value.replace(/[^a-zA-Z0-9\s]/gi, "");     
        } 
        this.setState(newState);
    }
    changeHandler(p) {
        var newState = {};
        newState[p.target.name] = p.target.value;
        this.setState(newState);
    }

    GetSelectedRecords_Id = (childData) => {
        debugger;
        this.setState({ vehicleHealthId: childData.vehicleHealthId });
        if(childData.vehicleHealthId > 0)
        {
            this.setState({openModel:true})
        }
          
        

      }

    closeModel(e) {
        this.setState({ openModel: false });
    }

    async bindGrid(){
        let token = localStorage.getItem('token');
        console.log(this.state);
        let cards = []
        await this.setState(
            {
                VRNMappingID: 1021
            })

        axiosConfig.defaults.headers.common['Token'] = token;
        axiosConfig.post("Portal/GetVehicleHealthActivityReminder",
            {
                  SearchTypeID: this.state.Option,
                  VRNMappingID: this.state.Vehicle,
                  VRNGroupingID: this.state.Group,
                  UserAccountBranchId: this.props.data.selectedBranchId,
            }
        )
            .then(Response => {
                this.setState({
                    Activitydata: Response.data.lstActivityDetail
                });
            })
            .catch(error => {
                Swal.fire({
                    title: error.response.data.errorMessage,
                    text: 'Some Error !',
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            })
    }

    async submitHandler(e) {

        e.preventDefault();
       await this.bindGrid();

    };

    async optionChange(selectedOption) {
        if ( selectedOption == 1) {
            await this.setState({ Option: parseInt(selectedOption), Group: 0, Vehicle: 0 })
            this.bindGrid();

        }
       
    }

    async vehicleChange(selectedVehicle) {
        await this.setState({ Vehicle: selectedVehicle, Group: 0 })
        this.bindGrid();
    }

    async groupChange(selectedGroup) {
        await this.setState({ Group: selectedGroup, Vehicle: 0 })
        this.bindGrid();

    }

    GetDeleteSelectedRecords = (childData) => {

        

        this.setState({ DeletedRecordId: childData.vehicleHealthId })

    
        const data = {
            VehicleHelathId: this.state.DeletedRecordId,
            UserId: this.state.UserBranchID
        }
        axiosConfig.post("Portal/GetDeleteVehicleHealthActivityReminder",data)
            .then(res => {
                 this.bindGrid();
              Swal.fire(
                'Deleted!',
                'Record has been deleted.',
                'success'
              )
            })
            .catch(error => {
                Swal.fire({
                    title: error.response.data.errorMessage,
                    text: 'Some Error !',
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            })
      }

    render() {

        const {activityMarkedDate,activityMarkedComments}=this.state;
        return (
            <>
            

                <section id="multiple-column-form">
                    <div className="row match-height">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <h4 className="card-title">My Reminders</h4>
                                </div>
                                <div className="card-content">
                                    <div className="card-body"></div>
                                    <div>
                                        <Container>
                                            <Row>
                                                <GroupVRNSelect
                                                    showVehiclesInDropDown='yes'
                                                    onOptionChange={this.optionChange}
                                                    onGroupChange={this.groupChange}
                                                    onVehicleChange={this.vehicleChange}
                                                />
                                                <div className="col-md-6 col-12" style={{ textAlign: 'left',marginTop: '8px' }}>
                                                    <button type="submit" className="btn btn-shell mr-1 mb-1" onClick={this.submitHandler} >Generate Report</button>
                                                </div>
                                            </Row>
                                        </Container>
                                    </div><br />
                                    <div className="form-body">
                                        <div className="row">
                                            {/* <div className="col-md-6 col-12">
                                                    <div className="form-label-group">
                                                        <input type="date" id="StartTime" name="StartTime" value={this.state.StartTime} onChange={this.changeHandler} className="form-control" />
                                                        <label htmlFor="country-floating">Choose Start Time</label>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 col-12">
                                                    <div className="form-label-group">
                                                        <input type="date"  id="EndTime" name="EndTime" value={this.state.EndTime} onChange={this.changeHandler} className="form-control" />
                                                        <label htmlFor="country-floating">Choose End Time</label>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 col-12" id="text"> 
                                                    <div className="form-label-group">
                                                        <Select 
                                                            options={this.state.entriesOptions}
                                                            styles={customStyles}
                                                            placeholder={'Display Entries on Page'}
                                                        />
                                                    </div>
                                                </div>
                                                {/* col-12 */}

                                        </div>
                                        <div className="row">
                                            <div className="col-md-12 col-12">
                                                <AdvanceTableWithActionButton
                                                 parentDeletedObjectCallback={this.GetDeleteSelectedRecords}
                                                 parentRowIdObjectCallback={this.GetSelectedRecords_Id}
                                                 data={this.state.Activitydata} 
                                                 columns={this.state.Activitycolumns}>
                                                </AdvanceTableWithActionButton>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Modal show={this.state.openModel} onHide={this.closeModel} animation={true} centered style={{ zIndex: 99999 }}>
                        <Modal.Header closeButton>
                            <Modal.Title>Mark As Done </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                  
                            <form  >
                                <div className="modal-body">
                                    <label>Name: </label>
                                    <div className="form-group">
                                        <input type="date" placeholder="Activity Date" className="form-control" name="activityMarkedDate" value={this.state.activityMarkedDate} onChange={this.onChange} required />
                                    </div>
                                    <label>Comments: </label>
                                    <div className="form-group">
                                        <input placeholder="Comments" className="form-control" name="activityMarkedComments" value={this.state.activityMarkedComments} onChange={this.onChange} maxLength="50" />
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <Button variant="secondary" onClick={this.closeModel}>Close</Button>
                                    <button className="btn btn-shell" onClick={this.MarkAsDoneSave} >Submit</button>
                                </div>
                            </form>
                        </Modal.Body>
                    </Modal>
                
               
                </section>
            </>
        );
    }
}

export default MyReminderActivity;









